import React from "react";
import AddEditProfile from "./AddEditProfile";

function EmployeesList(props) {
  // const [addEditModel, setAddEditModel] = useState(false);
  return (
    <div>
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
        <div className="grid grid-cols-12 gap-6 w-full ">
          <div className="xl:col-span-12 lg:col-span-12 col-span-12">
            <div className="shadow-md">
              {props.employeeList.map((emp, key) => (
                <>
                  <div className="tab w-full overflow-hidden border-t">
                    <input
                      className="absolute opacity-0"
                      id={key}
                      type="radio"
                      name="tabs2"
                    />
                    <label
                      className="flex items-center justify-between relative py-5 px-12 w-auto leading-normal cursor-pointer"
                      for={key}
                    >
                      <span className="text-[#005B9C] text-xl font-bold w-[40%]">
                        {emp.firstName} {emp.lastName}
                      </span>

                      <span className="text-[#000000] text-xl w-[40%]">
                        {emp.designation}
                      </span>
                      <span className="w-[10%]">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            props.setAddEditModel(true);
                            props.onEditEmployee(emp.individualMemberId)
                            props.setLoader(false);
                          }}
                          disabled={props.isDisabledFlag ? true : false}
                          className={`underline text-xl text-[#8DA4B5] ${props.isDisabledFlag ? 'cursor-not-allowed' : null}`}
                        >
                          Edit Profile
                        </button>
                      </span>
                    </label>
                    <div className="tab-content overflow-hidden leading-normal px-12">
                      <h2 className="text-xl text-[#000000] 2xl:mb-1 flex items-center">
                        <span className="w-[15%]">Email:</span>{" "}
                        <span className="ml-5">{emp.email}</span>
                      </h2>
                      <h2 className="text-xl text-[#000000] 2xl:mb-1 lg:mb-5 flex items-center">
                        <span className="w-[15%]">Contact Number:</span>{" "}
                        <span className="ml-5">{emp.contactNo}</span>
                      </h2>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="add-edite-employee-popup">
        <AddEditProfile
          mrMrs={props.mrMrs}
          emailDomain={props.emailDomain}
          employeeDetails={props.employeeDetails}
          handleChange={props.handleChange}
          setFilterParameters={props.setFilterParameters}
          saveEmployee={props.saveEmployee}
          // addEditModel={addEditModel}
          setOpenModal={() => props.setAddEditModel(false)}
          validate={props.validate}
          validState={props.validState}
          domainArr={props.domainArr}
          onClose={(e) => {
            e.stopPropagation();
            props.setAddEditModel(false);
          }}
          handleChangeMultiDropdown={props.handleChangeMultiDropdown}
          designationList={props.designationList}
          isLoaderOn={props.isLoaderOn}
          setLoader={props.setLoader}
          addEditModel={props.addEditModel}
          setAddEditModel={props.setAddEditModel}

        />
      </div>
    </div>
  );
}

export default EmployeesList;
